import { Remove } from '@mui/icons-material';
import { IconButton, useTheme } from '@mui/material';
import { AddIcon } from '@shared/custom-icons';
import { useDisclosure } from '@shared/hooks';
import { PropsWithChildren } from 'react';
import { FilterField } from './FilterField';

export interface CollapsibleFilterFieldProps extends PropsWithChildren {
  label: string;
  description?: string;
  gap?: number;
  defaultOpen?: boolean;
  open?: boolean;
  onToggle?: () => void;
}

export function CollapsibleFilterField({
  label,
  description,
  gap,
  defaultOpen = true,
  open,
  onToggle,
  children,
}: CollapsibleFilterFieldProps) {
  const theme = useTheme();
  const { isOpen, onToggle: toggleInternal } = useDisclosure(defaultOpen);

  const isExpanded = open ?? isOpen;
  const toggle = onToggle ?? toggleInternal;

  return (
    <FilterField
      label={label}
      description={description}
      gap={gap}
      action={
        <IconButton
          size="small"
          sx={{ p: 0.25 }}
          onClick={toggle}
          aria-expanded={isExpanded}
          aria-label={label}
        >
          {isExpanded ? (
            <Remove fontSize="small" />
          ) : (
            <AddIcon stroke={theme.vars.palette.text.secondary} fontSize="small" />
          )}
        </IconButton>
      }
    >
      {isExpanded && children}
    </FilterField>
  );
}
